/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tpm_Field_NotesInputs */

const en_tpm_field_notes = /** @type {(inputs: Tpm_Field_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Describe the problem`)
};

const ja_tpm_field_notes = /** @type {(inputs: Tpm_Field_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`問題の内容`)
};

const fr_tpm_field_notes = /** @type {(inputs: Tpm_Field_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Décrire le problème`)
};

const de_tpm_field_notes = /** @type {(inputs: Tpm_Field_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Problem beschreiben`)
};

/**
* | output |
* | --- |
* | "Describe the problem" |
*
* @param {Tpm_Field_NotesInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const tpm_field_notes = /** @type {((inputs?: Tpm_Field_NotesInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tpm_Field_NotesInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tpm_field_notes(inputs)
	if (locale === "ja") return ja_tpm_field_notes(inputs)
	if (locale === "fr") return fr_tpm_field_notes(inputs)
	return de_tpm_field_notes(inputs)
});